import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class UpdateSyncHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/updateSyncHistory',
      requesterInfo,
    })
  }

  public async updateSyncHistory(req: number): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
